import { GET_PAYMENT_METHOD_REQUEST, GET_PAYMENT_METHOD_SUCCESS, GET_PAYMENT_METHOD_ERROR } from "../actions/types";
export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PAYMENT_METHOD_REQUEST:
      return {
        loading: true,
      };
    case GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_PAYMENT_METHOD_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    default:
      return state;
  }
}
